import React, { useRef, useEffect } from "react";
import { Container } from "react-bootstrap";

const Embeded = () => {
    const competitionRef = useRef(null);

    const embedCompetition = (html) => {
        const el = competitionRef.current;
        if (el) {
            el.innerHTML = html;

            const scripts = el.querySelectorAll("script");
            scripts.forEach((oldScript) => {
                const newScript = document.createElement("script");
                Array.from(oldScript.attributes).forEach((attr) =>
                    newScript.setAttribute(attr.name, attr.value)
                );
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        }
    };

    const embedCode = `
<a class="e-widget no-button generic-loader" href="https://gleam.io/GBP3F/polaris-call-of-duty-season-1-giveaway" rel="nofollow">
  POLARIS + CALL OF DUTY® SEASON 1 GIVEAWAY
</a>
<script type="text/javascript" src="https://widget.gleamjs.io/e.js" async="true"></script>
    `;

    useEffect(() => {

        console.log("Embedding the competition");
        embedCompetition(embedCode);

    }, [embedCode]);

    return (
        <>
            <Container >

                <div id="gleam_competition" className="mb-5" ref={competitionRef}></div>


            </Container>
        </>

    );
};

export default Embeded;
